import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

// import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import Home from './Home/Home';
import Login from './Auth/Login';
import SignUp from './Auth/SignUp';
import UpdatePassword from './Auth/UpdatePassword';

import { AuthProvider } from '../Context/AuthContext';
import PrivateRoute from './PrivateRoute';
import ClassChat from './ClassChat';
// import SavedNotes from './SavedNotes';

import SavedNotes from './SavedNotes copy';

import HomeworkHelp from './HomeworkHelp';
import { SocketProvider } from '../Context/SocketContext';
import StudyChat from './StudyChat';
import SmartNotes from './SmartNotes';
import QuizCard from './TestMeMode/QuizCard';
import QuizScoreCard from './TestMeMode/QuizScoreCard';
import Create from './TestMeMode/Create';
import TestMeMode from './TestMeMode';
import SubscriptionPage from './Subscription';
import ProcessingPage from './Subscription/ProcessingPage';
function App() {
  return (
    <>
      <Router>
        <AuthProvider>
          <Switch>
            <PublicRoute exact path="/login" component={Login} />
            <PublicRoute exact path="/register" component={SignUp} />
            <PublicRoute
              exact
              path="/update-password"
              component={UpdatePassword}
            />

            <PrivateRoute exact path="/quizCard" component={QuizCard} />
            <PrivateRoute exact path="/configureQuiz" component={Create} />
            <PrivateRoute
              exact
              path="/quizScoreCard"
              component={QuizScoreCard}
            />

            <PrivateRoute path="/quiz" component={TestMeMode} />
          </Switch>
          <SocketProvider>
            <Switch>
              <PrivateRoute exact path="/savedNotes" component={SavedNotes} />
              <PrivateRoute path="/view/:type" component={SavedNotes} />
              <PrivateRoute exact path="/" component={StudyChat} />
              <PrivateRoute exact path="/testMeMode" component={StudyChat} />
              <PrivateRoute exact path="/classChat" component={ClassChat} />
              <PrivateRoute
                exact
                path="/classChat/:name"
                component={ClassChat}
              />
              <PrivateRoute
                exact
                path="/homeworkHelp"
                component={HomeworkHelp}
              />
              <PrivateRoute path="/smartNotes" component={SmartNotes} />
              <PrivateRoute
                path="/manage-subscription"
                component={SubscriptionPage}
              />
              <PrivateRoute path="/paymentStatus" component={ProcessingPage} />
            </Switch>
          </SocketProvider>
        </AuthProvider>
      </Router>
    </>
  );
}

export default App;
